import React from "react";
import { ShimmerLine } from "../../../../Shimmer/ShimmerLine/ShimmerLine";
import { Stack } from "../../../../Stacks/Stack/Stack";
import { LineShimmerColumnProps } from "../LineShimmerColumn/LineShimmerColumn";
import { defaultLineShimmerWidth, lineShimmerHeight, MediaShimmerSizes } from "../shared/styles";

export interface MediaShimmerColumnProps extends LineShimmerColumnProps {
    /**
     * ListItemMedia props to create text elements.
     */
    readonly mediaShimmerSize: MediaShimmerSizes;
}

export const MediaShimmerColumn: React.FC<MediaShimmerColumnProps> = ({
    mediaShimmerSize,
    shimmerLineProps
}) => {
    return (
        <Stack horizontal={true} childrenGap="0 10px" verticalAlign="center">
            <ShimmerLine height={mediaShimmerSize} width={mediaShimmerSize} />
            <Stack horizontal={false}>
                {shimmerLineProps.map((prop, index) => (
                    <Stack margin={(index === shimmerLineProps.length - 1) ? "" : "0 0 4px 0"} key={index}>
                        <ShimmerLine
                            height={lineShimmerHeight}
                            width={prop.width ? prop.width : defaultLineShimmerWidth}
                            shimmerColors={prop.shimmerColors}
                        />
                    </Stack>
                ))}
            </Stack>
        </Stack>
    );
};
